import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';

const NewsEvents = () => {
  const [news, setNews] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    // Fetch News & Events
    axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/news_events.php')
      .then(response => {
        setNews(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the news and events!", error);
      });
  }, []);

  const handleNewsClick = (newsId) => {
    navigate(`/news-and-events/${newsId}`); // Use navigate to redirect
  };

  return (
    <div>
      {/* Navbar */}
      <Navbar />
      {/* Navbar Ending */}

      {/* Page Content starts here */}
      <section className="page-section">
        <div className="section-content">
          <p className='page-heading'>News & Events</p>

          <div className="d-none d-md-block"> {/* Visible on desktop, hidden on mobile */}
            <p className="page-subtitle">
              Stay Informed with the Latest Updated and Activities
              <br/> 
              at Caritas Matha Hospital
            </p>
          </div>

          <div className="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
            <p className="page-subtitle">
              Stay Informed with the Latest Updated and Activities at Caritas Matha Hospital
            </p>
          </div>
          
          <p>&nbsp;</p>

          <div className="articles-container">
            {news.map((news, index) => (
                <div className="article-card" key={index}>
                  <a href="" className="article-title"><img src={news.image_url} className="article-image" onClick={() => handleNewsClick(news.id)} /></a>
                  <div className="article-info">
                    <a href="" className="article-title"><h6 onClick={() => handleNewsClick(news.id)}>{news.title}</h6></a>
                    <p>{new Date(news.created_date).toLocaleDateString('default', { month: 'long', year: 'numeric' })}</p>
                  </div>
                </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
      {/* Footer Ending */}
    </div>
  );
}

export default NewsEvents;
